import React from 'react'
import { withStyles } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { sectionDrawerOpen } from 'src/reducers/course/action'
import styles from './styles' // Import the styles from styles.js
import { Icon } from '@iconify/react'

const MidButton = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const open = useSelector(state => state.course.sectionDrawerOpen)

  const handleDrawer = () => {
    dispatch(sectionDrawerOpen())
  }

  return (
    <div
      className={classes.container}
      onClick={handleDrawer}
      style={{
        left: open ? '296px' : '72px',
      }}
    >
      <img
        src={'/assets/open-close-component.svg'}
        alt="button"
        className={classes.buttonImage}
      />
      <Icon
        icon="ic:round-chevron-right"
        className={classes.icon}
        style={{
          transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
        fontSize={20}
      />
    </div>
  )
}

export default withStyles(styles)(MidButton)
